import { useTLang } from 'intl/intl';

export function useMozartDefectSolvedLang(props: Props) {
  const { productName = '' } = props;

  return {
    dialog: {
      header: {
        title: useTLang({ id: 'notification.mozart.035' }),
      },
      action: {
        primaryBtn: useTLang({ id: 'notification.mozart.022' }),
      },
    },
    infoCard: {
      title: useTLang({ id: 'notification.mozart.025' }),
    },
    form: {
      legend: useTLang({ id: 'notification.mozart.012' }),
      option: {
        cooking: {
          title: useTLang({ id: 'notification.mozart.014' }),
        },
        stock: {
          title: useTLang({ id: 'notification.mozart.040' }),
        },
        packaging: {
          title: useTLang({ id: 'notification.mozart.028' }),
        },
        other: {
          title: useTLang({ id: 'notification.mozart.032' }),
          placeholder: useTLang({ id: 'notification.mozart.048' }),
          numberOfCharacters: useTLang({ id: 'notification.mozart.001' }),
        },
      },
    },
    snackBar: {
      success: {
        solved: {
          title: useTLang({ id: 'notification.mozart.036' }),
          msg: '',
        },
        turnOnProduct: {
          title: useTLang({ id: 'notification.mozart.007' }),
          msg: useTLang({ id: 'notification.mozart.026' }, { productName }),
        },
      },
      error: {
        title: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.title' }),
        msg: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.msg' }),
      },
    },
  };
}

interface Props {
  productName?: string;
}
